<template>
    <div :class="buttonContainerDivClass">
        <b-button :variant="buttonColor" class="mb-2 w-100" @click="openModal">
            <i :class="buttonIcon"></i> {{ buttonText }}
        </b-button>
        <b-modal
            size="lg"
            ref="add-hashtagset-modal"
            id="add-hashtagset-modal"
            centered
            title="Create new hashtag set"
        >
            <!-- Page preloader -->
            <PagePreloader v-if="modalisloading">hashtags</PagePreloader>
            <!-- Error management -->
            <CustomAlerts :errors="errors"></CustomAlerts>

            <form method="POST" ref="addHashtagSetForm" v-on:submit.prevent="addHashtagSet">
                <!-- Emoji picker -->
                <b-form-group
                    label-cols="4"
                    label-cols-lg="2"
                    label="Icon"
                    label-for="input-default"
                >
                    <emojiPicker @emitSavedEmoji="handleEmitEmoji"></emojiPicker>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="2"
                    label="Title"
                    label-for="input-default"
                >
                    <b-form-input
                        id="title"
                        name="title"
                        placeholder="Enter the title for your hashtag set"
                        v-model="form.title"
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    label-cols="4"
                    label-cols-lg="2"
                    label="Hashtags"
                    label-for="input-default"
                >
                    <b-form-textarea
                        id="hashtags"
                        name="hashtags"
                        placeholder="Enter hashtags here..."
                        rows="3"
                        max-rows="6"
                        :value="form.hashtags"
                        v-model="form.hashtags"
                    ></b-form-textarea>
                </b-form-group>

                <ModalContentHashtagSetSharing :form="form"></ModalContentHashtagSetSharing>

                <!-- NOTE - Template managmeent to enable or not -->
                <!-- Check if share is enabled -->
                <!-- <template v-if="currentUser.hashtag_share_enabled">
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Share this hashtag set with others?"
                        label-for="input-default"
                    >
                        <b-form-checkbox
                            switch
                            size="lg"
                            class="pt-2"
                            name="meta_is_shared"
                            :value="1"
                            :unchecked-value="0"
                            v-model="form.meta_is_shared"
                        >
                        </b-form-checkbox>
                    </b-form-group>

                    <template v-if="form.meta_is_shared != 0">
                        <b-form-group
                            label-cols="4"
                            label-cols-lg="2"
                            label="Can other users edit this Hashtag Set?"
                            label-for="input-default"
                        >
                            <b-form-checkbox
                                switch
                                size="lg"
                                class="pt-2"
                                name="meta_is_editable_by_sharees"
                                :value="1"
                                :unchecked-value="0"
                                v-model="form.meta_is_editable_by_sharees"
                            >
                            </b-form-checkbox>
                        </b-form-group>

                        <template v-if="shareesIsLoaded">
                            <b-form-group
                                label-cols="4"
                                label-cols-lg="2"
                                label="Who is this hashtag set shared with?"
                                label-for="input-default"
                            >
                                <b-form-select
                                    size="lg"
                                    class="pt-2"
                                    v-model="form.sharees_selected"
                                    :options="shareesOptions"
                                    multiple
                                    :select-size="4"
                                ></b-form-select>
                            </b-form-group>
                        </template>
                    </template>
                </template> -->

                <!-- Hashtag Groups -->
                <template v-if="mygroups.length > 0">
                    <b-form-group
                        label-cols="4"
                        label-cols-lg="2"
                        label="Hashtag Group"
                        label-for="input-default"
                    >
                        <b-form-select
                            name="group"
                            v-model="addHashtagSetSelectedGroup"
                            :options="addHashtagSetGroupOptions"
                        ></b-form-select>
                    </b-form-group>
                </template>
                <template v-if="mygroups.length < 1">
                    <input type="hidden" name="group" value="" />
                </template>
                <input type="submit" class="d-none" :disabled="modalisloading" />
            </form>

            <template v-slot:modal-footer="{ ok, cancel, hide }">
                <b-button
                    type="submit"
                    variant="success"
                    @click="addHashtagSet"
                    :disabled="modalisloading"
                >
                    Create new hashtag set
                </b-button>
                <!-- Button with custom close trigger value -->
                <b-button variant="outline-secondary" @click="hide()"> Cancel </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
// Defaults
import axios from "axios";
import { mapGetters } from "vuex";
// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
import emojiPicker from "@/view/content/Custom/emojiPicker.vue";
import ModalContentHashtagSetSharing from "@/view/content/Custom/ModalContentHashtagSetSharing.vue";
// Mixins
import axiosErrorManagement from "@/mixins/axiosErrorManagement";

export default {
    name: "buttonAddHashtagSet",
    mixins: [axiosErrorManagement],
    components: {
        CustomAlerts,
        PagePreloader,
        emojiPicker,
        ModalContentHashtagSetSharing,
    },
    props: {
        // Pass through
        propHashtags: String,
        propMyHashtags: Array,
        updateMyHashtags: {
            type: Boolean,
            default: false,
        },
        buttonLocation: {
            type: String,
            default: "wild",
        },
        // Formatting
        buttonText: {
            type: String,
            default: "Save hashtag set",
        },
        buttonColor: {
            type: String,
            default: "primary",
        },
        buttonContainerDivClass: {
            type: String,
            default: "d-inline pr-2 pl-2",
        },
        buttonIcon: {
            type: String,
            default: "fas fa-save",
        },
    },
    data() {
        return {
            // Errors
            errors: [],

            // Displayers
            modalisready: false,

            // Group management
            addHashtagSetSelectedGroup: null,
            addHashtagSetGroupOptions: [],
            mygroups: [],

            // Preloaders
            modalisloading: false,

            // Form
            form: {
                title: "",
                hashtags: "",
                sharees_selected: [],
                meta_is_shared: 0,
                meta_is_editable_by_sharees: 0,
            },
            selectedEmoji: null,
            shareesOptions: [],
        };
    },
    methods: {
        // Open modal
        openModal() {
            // Refresh errors
            this.errors = [];

            // Reset
            this.selectedEmoji = null;
            this.form.sharees_selected = [];
            this.shareesOptions = [];
            this.form.meta_is_shared = 0;
            this.form.meta_is_editable_by_sharees = 0;

            // Reset data if our location is other than the "My Hashtags" page, e.g. a save button somewhere in the wild
            if (this.buttonLocation != "myhashtags") {
                this.form.hashtags = this.propHashtags;
            }

            // Get current groups
            axios
                .get("myhashtagsv2/groups/basic")
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Set data
                    this.mygroups = data;

                    // Reset the select
                    this.addHashtagSetGroupOptions = [];
                    this.addHashtagSetGroupOptions.push({ value: null, text: "Uncategorized" });

                    // Check
                    if (data.length > 0) {
                        data.forEach((currentItem) => {
                            var curEmoji = "";
                            if (currentItem.emoji && currentItem.emoji != null) {
                                curEmoji = currentItem.emoji;
                            }
                            this.addHashtagSetGroupOptions.push({
                                value: currentItem.id,
                                text: curEmoji + " " + currentItem.title,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    this.modalisready = true;
                });

            // Get potential users that we can share with
            // if (this.currentUser.hashtag_share_enabled) {
            //     // Reset blocker
            //     this.shareesIsLoaded = false;

            //     // Perform axios
            //     axios
            //         .get("myhashtagsv2/sharees")
            //         .then((response) => {
            //             // Make pretty
            //             var data = response.data;

            //             // Check
            //             if (data.status == "OK") {
            //                 data.data.forEach((currentItem) => {
            //                     this.shareesOptions.push({
            //                         value: currentItem.id,
            //                         text: currentItem.username + " - " + currentItem.email,
            //                     });
            //                 });
            //                 // data.forEach((currentItem) => {
            //                 //     var curEmoji = "";
            //                 //     if (currentItem.emoji && currentItem.emoji != null) {
            //                 //         curEmoji = currentItem.emoji;
            //                 //     }
            //                 //     this.addHashtagSetGroupOptions.push({
            //                 //         value: currentItem.id,
            //                 //         text: curEmoji + " " + currentItem.title,
            //                 //     });
            //                 // });
            //             }
            //         })
            //         .catch((error) => {
            //             this.errors.push(this.handleAxiosErrors(error));
            //         })
            //         .finally(() => {
            //             this.shareesIsLoaded = true;
            //         });
            // }

            // Open modal
            this.$refs["add-hashtagset-modal"].show();
        },

        // Perform query
        addHashtagSet() {
            // Reset errors
            this.errors = [];

            // Loader
            this.modalisloading = true;

            // Get emoji
            var emoji = this.selectedEmoji;

            // Get group
            var group = this.$refs.addHashtagSetForm.group.value;

            // Perform
            axios
                .post("myhashtagsv2/create", {
                    title: this.form.title,
                    hashtags: this.form.hashtags,
                    emoji: emoji,
                    group: group,
                    sharees: this.form.sharees_selected,
                    meta_is_shared: this.form.meta_is_shared,
                    meta_is_editable_by_sharees: this.form.meta_is_editable_by_sharees,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Handle status
                    if (data.status == "OK") {
                        // Check if we need to pass things through
                        if (this.buttonLocation == "myhashtags") {
                            if (group) {
                                this.propMyHashtags.push(data.data); // Adds to the end of the array
                            } else {
                                this.propMyHashtags.unshift(data.data); // Adds to the beginning of the array
                            }
                        }

                        // Remove all errors
                        this.errors = [];

                        // Reset form
                        this.form.title = "";
                        this.form.hashtags = "";
                        this.addHashtagSetSelectedGroup = null;

                        // Close the modal
                        this.$refs["add-hashtagset-modal"].hide();

                        // Emit
                        this.$emit("emitPassMessage", data.messages);
                    }

                    // Check for errors
                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.errors.push({ type: item.type, message: item.message });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Close preloader
                    this.modalisloading = false;
                });
        },

        handleEmitEmoji(emoji) {
            this.selectedEmoji = emoji;
        },
    },
    computed: {
        ...mapGetters({ currentUser: "auth/currentUser" }),
    },
};
</script>
